module.exports = __webpack_public_path__ + "static/media/19ESCAP40.6510412e.jpg";